
import { defineComponent } from 'vue';
import SvgIcon from '@/components/SvgIcon.vue';
import myModal from '@/components/Modal.vue';
import PersonCenter from '@/views/Public/UserInfo.vue';
import ControllerFun from './js';
import '@/assets/icons/user.svg';
import '@/assets/icons/bell.svg';
import '@/assets/icons/help.svg';
import '@/assets/icons/exit.svg';

export default defineComponent({
  components: {
    SvgIcon,
    myModal,
    PersonCenter,
  },
  props: {},
  setup() {
    const controllers = ControllerFun();
    return {
      ...controllers,
    };
  },
});
